import * as React from "react";
import { Typography, Box, Stack } from "@mui/material";
import { ResponsiveContainer } from "@/components/dashboard/ResponsiveContainer";
import { InformationGrid } from "@/components/dashboard/InformationGrid";
import { PortfolioSummarySection } from "@/components/portfolio/sections/PortfolioSummarySection";
import { HoldingsSection } from "@/components/portfolio/sections/HoldingsSection";
import { PositionsSection } from "@/components/portfolio/sections/PositionsSection";
import { PortfolioHealthSection } from "@/components/portfolio/sections/PortfolioHealthSection";
import { PortfolioSystemInformationSection } from "@/components/portfolio/sections/PortfolioSystemInformationSection";

export function PortfolioPage(): React.JSX.Element {
  return (
    <ResponsiveContainer>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" gutterBottom>
          Portfolio
        </Typography>
        <Typography variant="body2" color="text.secondary">
          Live backend portfolio, holdings, and position data — no calculated values.
        </Typography>
      </Box>
      <InformationGrid>
        <PortfolioSummarySection />
        <PortfolioHealthSection />
        <PortfolioSystemInformationSection />
      </InformationGrid>
      <Stack spacing={3} sx={{ mt: 3 }}>
        <HoldingsSection />
        <PositionsSection />
      </Stack>
    </ResponsiveContainer>
  );
}
